import { useEffect, useState } from 'react';

export const useOrientation = () => {
  const orientationValue =
    window.innerWidth > window.innerHeight ? 'LANDSCAPE' : 'PORTRAIT';
  const [orientation, setOrientation] = useState<'LANDSCAPE' | 'PORTRAIT'>(
    orientationValue
  );

  const handleResize = () => {
    setOrientation(
      window.innerWidth > window.innerHeight ? 'LANDSCAPE' : 'PORTRAIT'
    );
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return orientation;
};
